import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom'
import moment from 'moment-jalaali'
import {

} from '@material-ui/icons'
import DeleteIcon from 'src/icons/DeleteIcon'
import EditIcon from 'src/icons/EditIcon'
import {
  Button,
  Dialog,
  IconButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { ThemeProvider } from '@material-ui/core/styles'
import { getUsers, deleteUser } from '../../app/slices/usersSlice'
import { getMuiTheme } from '../../utils/TableStyle'

import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyles = makeStyles(() => ({
  root: {
    '&.MuiPaper-root': {
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  deleteModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',

      color: '#ffffff',
    },
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',

      color: '#ffffff',
    },
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      // width: '587px',
      width: '50%',
      height: '189px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#f5aca8, #eb5c55)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
}))

const UsersList = () => {
  const users = useSelector((state) => state.users.list)
  const totalUsers = useSelector((state) => state.users.total)
  const classes = useStyles()
  const loggedInUser = useSelector((state) => state.user)
  const roles = useSelector((state) => {
    if (loggedInUser.role.roleId === 5 || loggedInUser.role.roleId === 10) {
      return state.common.roles.filter((role) => role.roleId === 6)
    } if (loggedInUser.role.roleId === 3) {
      return state.common.roles.filter(
        (role) => (
          role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 8 && role.roleId !== 3
        ),
      )
    } if (loggedInUser.role.roleId === 2) {
      return state.common.roles.filter((role) => role.roleId !== 1)
    }
    return []
  })
  const dispatch = useDispatch()
  const [userIdToDelete, setUserIdToDelete] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [currentRole, setCurrentRole] = useState(roles.map((role) => role.roleId))
  const [searchTerm, setSearchTerm] = useState(null)
  console.log('setCurrentRole', currentRole)
  const updateSearchTerm = debounce((term) => {
    setSearchTerm(term)
  }, 500, { maxWait: 1000 })
  useEffect(() => {
    dispatch(getUsers({
      roleIds: currentRole.length ? currentRole : roles.map((role) => role.roleId),
      after: currentPage * rowsPerPage,
      first: rowsPerPage,
      full: true,
      userName: searchTerm,
    }))
  }, [refresh, currentRole, currentPage, rowsPerPage, searchTerm])

  const roleColumnNumber = 3
  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'profile',
      label: 'نام و نام خانوادگی',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (value ? `${value?.firstName} ${value?.lastName}` : null),
      },
    },
    {
      name: 'userName',
      label: 'نام کاربری',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'role.name',
      label: 'نقش',
      options: {
        sort: false,
        filter: true,
        customBodyRender: (value) => value,
        filterOptions: {
          fullWidth: true,
          names: roles.map((role) => role.name),
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ عضویت',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: false,
      },
    },
    {
      name: 'lastLoginDate',
      label: 'آخرین لاگین',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: false,
      },
    },
    {
      name: 'userId',
      label: 'مدیریت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <div>
              <Link to={`./edit/${value}`}>
                <IconButton onClick={() => {
                  setUserIdToDelete(value)
                }}
                >
                  <EditIcon className={classes.icons} />
                </IconButton>
              </Link>
              <IconButton onClick={() => {
                setUserIdToDelete(value)
              }}
              >
                <DeleteIcon
                  className={classes.icons}
                />
              </IconButton>
            </div>
          )
        },
      },
    },
  ]

  const handleClose = (shouldDelete) => {
    if (shouldDelete) {
      dispatch(deleteUser(
        userIdToDelete, () => setRefresh(!refresh),
      ))
    }
    setUserIdToDelete(null)
  }

  return (
    <>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          data={users}
          customSearch={(
            <div style={{ width: '100%', backgroundColor: 'red' }}>
              <Button>Click Here</Button>
              Table Title
            </div>
)}
          columns={COLUMNS}
          options={{
            searchPlaceholder: 'جستجو بر اساس نام کاربری',
            ...muiDefaultOptions,
            enableNestedDataAccess: '.',
            filterType: '',
            searchOpen: false,
            serverSide: true,
            count: totalUsers,
            page: currentPage,
            rowsPerPage,
            onTableChange: (action, state) => {
              switch (action) {
                case 'changeRowsPerPage':
                  setRowsPerPage(state.rowsPerPage)
                  break
                case 'filterChange':
                  if (!state.filterList[roleColumnNumber].length) {
                    setCurrentRole([])
                  } else {
                    const roleIds = state.filterList[roleColumnNumber].map((roleName) => roles.find(
                      (role) => role.name === roleName,
                    )?.roleId)
                    setCurrentRole(roleIds)
                  }
                  break
                case 'changePage':
                  setCurrentPage(state.page)
                  break
                case 'search':
                  updateSearchTerm(state.searchText)
                  break
                default:
                  break
              }
            },
            rowHover: false,
            selectableRows: 'none',
          }}
        />
      </ThemeProvider>
      <Dialog
        className={classes.deleteDialog}
        // style={{ width: '50%' }}
        open={userIdToDelete}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">حذف کاربر</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            آیا از حذف این کاربر اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.deleteModalBtn} autoFocus>
            حذف
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default UsersList
